import React from 'react';

function Liechtenstein(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124074)">
        <mask
          id="mask0_800_124074"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124074)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#E31D1C"
          />
          <mask
            id="mask1_800_124074"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124074)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V12H36V0H0Z"
              fill="#2E42A5"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.39819 11.0532C5.39819 11.0532 6.75569 11.8043 9.90138 11.8043C13.0471 11.8043 14.7168 11.0532 14.7168 11.0532C14.7168 11.0532 12.2499 9.77844 10.0441 9.77844C7.83832 9.77844 5.39819 11.0532 5.39819 11.0532Z"
              fill="black"
            />
            <path
              d="M5.47916 6.74221L5.26999 6.87913L5.34401 6.99221H5.47916H14.8451H15.0215L15.0806 6.82595L14.8451 6.74221C15.0806 6.82595 15.0806 6.82587 15.0807 6.82577L15.0808 6.82555L15.081 6.82495L15.0816 6.82321L15.0835 6.81751L15.0903 6.79755C15.0959 6.78052 15.1037 6.75617 15.1131 6.72527C15.1318 6.6635 15.1567 6.57529 15.1825 6.46687C15.2339 6.25078 15.2896 5.95058 15.3052 5.61718C15.3357 4.96094 15.2117 4.11118 14.5068 3.56644C13.8022 3.02202 12.9117 3.10442 12.1264 3.27888C11.8591 3.33827 11.5877 3.41257 11.3318 3.48261C11.2103 3.5159 11.0922 3.54822 10.9798 3.57752C10.6186 3.67165 10.3102 3.73624 10.0584 3.73624C9.80754 3.73624 9.53447 3.67638 9.22163 3.58884C9.12524 3.56187 9.02374 3.53182 8.91859 3.50069C8.69477 3.43444 8.45446 3.3633 8.21198 3.30658C7.47958 3.13525 6.64104 3.07123 5.70795 3.54097C5.22377 3.78471 4.94018 4.12729 4.80444 4.51235C4.67144 4.88965 4.68839 5.2844 4.75876 5.62856C4.82937 5.97393 4.95724 6.28541 5.06529 6.50803C5.11966 6.62005 5.16986 6.71131 5.20684 6.77514C5.22535 6.80709 5.2406 6.83228 5.25149 6.84986L5.26442 6.87047L5.26818 6.87633L5.26933 6.87812L5.26973 6.87872L5.26988 6.87895C5.26994 6.87905 5.26999 6.87913 5.47916 6.74221Z"
              fill="#FFD83D"
              stroke="black"
              strokeWidth="0.5"
            />
            <path
              d="M4.50293 7.12717L4.39688 6.90077L4.18143 7.0017L4.27157 7.22188L5.56865 10.3902L5.65177 10.5933L5.86385 10.5372L5.86387 10.5372L5.86389 10.5372L5.86404 10.5372L5.86498 10.5369L5.86916 10.5359L5.8866 10.5314C5.90219 10.5274 5.92563 10.5215 5.9564 10.5139C6.01795 10.4987 6.10879 10.4769 6.22478 10.4507C6.45682 10.3982 6.78917 10.328 7.18873 10.2579C7.98926 10.1173 9.05325 9.97775 10.1183 9.97775C11.1831 9.97775 12.2272 10.1173 13.0075 10.2577C13.397 10.3278 13.7193 10.3979 13.9438 10.4503C14.056 10.4765 14.1437 10.4982 14.203 10.5134C14.2326 10.5209 14.2552 10.5268 14.2702 10.5308L14.2869 10.5353L14.2908 10.5364L14.2917 10.5366L14.2918 10.5366L14.2919 10.5366L14.2919 10.5366L14.5034 10.5946L14.5884 10.3925L15.9214 7.22412L16.0146 7.00268L15.797 6.90077L15.691 7.12717C15.797 6.90077 15.7969 6.90073 15.7968 6.90068L15.7966 6.90057L15.796 6.90029L15.7943 6.8995L15.7889 6.89701L15.7699 6.88856C15.7536 6.88142 15.7301 6.87136 15.6994 6.85881C15.6379 6.83369 15.5475 6.79858 15.428 6.75683C15.1889 6.67334 14.8333 6.56335 14.36 6.45381C13.4131 6.2347 11.9957 6.01758 10.097 6.01758C8.1982 6.01758 6.78079 6.2347 5.83394 6.45381C5.36059 6.56335 5.00505 6.67334 4.76596 6.75683C4.64642 6.79858 4.55601 6.83369 4.49455 6.85881C4.46382 6.87136 4.44033 6.88142 4.42406 6.88856L4.40506 6.89701L4.39962 6.8995L4.39791 6.90029L4.39731 6.90057L4.39707 6.90068C4.39697 6.90073 4.39688 6.90077 4.50293 7.12717Z"
              fill="#FFD83D"
              stroke="black"
              strokeWidth="0.5"
            />
            <path
              d="M9.98287 4.26509C10.5641 4.26509 10.9892 3.74784 10.9892 3.16981C10.9892 2.59177 10.5641 2.07452 9.98287 2.07452C9.40168 2.07452 8.97656 2.59177 8.97656 3.16981C8.97656 3.74784 9.40168 4.26509 9.98287 4.26509Z"
              fill="#FFD83D"
              stroke="black"
              strokeWidth="0.5"
            />
            <mask
              id="path-10-outside-1_800_124074"
              maskUnits="userSpaceOnUse"
              x="8.13232"
              y="-1"
              width="4"
              height="5"
              fill="black"
            >
              <rect fill="white" x="8.13232" y="-1" width="4" height="5" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.2668 0H9.69954L9.77256 0.92272L9.13232 0.845283V1.47925L9.78239 1.39965L9.69954 2.85283H10.2668L10.1828 1.39721L10.834 1.47925V0.845283L10.1946 0.926867L10.2668 0Z"
              />
            </mask>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.2668 0H9.69954L9.77256 0.92272L9.13232 0.845283V1.47925L9.78239 1.39965L9.69954 2.85283H10.2668L10.1828 1.39721L10.834 1.47925V0.845283L10.1946 0.926867L10.2668 0Z"
              fill="#FFD83D"
            />
            <path
              d="M9.69954 0V-0.5H9.15841L9.2011 0.0394429L9.69954 0ZM10.2668 0L10.7653 0.0388159L10.8072 -0.5H10.2668V0ZM9.77256 0.92272L9.71252 1.4191L10.3192 1.49248L10.271 0.883277L9.77256 0.92272ZM9.13232 0.845283L9.19236 0.348901L8.63232 0.281163V0.845283H9.13232ZM9.13232 1.47925H8.63232V2.0442L9.19309 1.97554L9.13232 1.47925ZM9.78239 1.39965L10.2816 1.42811L10.3156 0.830629L9.72163 0.903359L9.78239 1.39965ZM9.69954 2.85283L9.20035 2.82437L9.17022 3.35283H9.69954V2.85283ZM10.2668 2.85283V3.35283H10.7964L10.7659 2.82403L10.2668 2.85283ZM10.1828 1.39721L10.2453 0.901126L9.64901 0.826007L9.68362 1.426L10.1828 1.39721ZM10.834 1.47925L10.7715 1.97532L11.334 2.04619V1.47925H10.834ZM10.834 0.845283H11.334V0.277433L10.7707 0.349304L10.834 0.845283ZM10.1946 0.926867L9.6961 0.888052L9.6484 1.50061L10.2579 1.42285L10.1946 0.926867ZM9.69954 0.5H10.2668V-0.5H9.69954V0.5ZM10.271 0.883277L10.198 -0.0394429L9.2011 0.0394429L9.27411 0.962163L10.271 0.883277ZM9.07229 1.34167L9.71252 1.4191L9.83259 0.426338L9.19236 0.348901L9.07229 1.34167ZM9.63232 1.47925V0.845283H8.63232V1.47925H9.63232ZM9.72163 0.903359L9.07156 0.982951L9.19309 1.97554L9.84316 1.89595L9.72163 0.903359ZM10.1987 2.88129L10.2816 1.42811L9.2832 1.37119L9.20035 2.82437L10.1987 2.88129ZM10.2668 2.35283H9.69954V3.35283H10.2668V2.35283ZM9.68362 1.426L9.7676 2.88163L10.7659 2.82403L10.682 1.36841L9.68362 1.426ZM10.8965 0.983166L10.2453 0.901126L10.1203 1.89328L10.7715 1.97532L10.8965 0.983166ZM10.334 0.845283V1.47925H11.334V0.845283H10.334ZM10.2579 1.42285L10.8973 1.34126L10.7707 0.349304L10.1313 0.430888L10.2579 1.42285ZM9.76828 -0.0388159L9.6961 0.888052L10.6931 0.965683L10.7653 0.0388159L9.76828 -0.0388159Z"
              fill="black"
              mask="url(#path-10-outside-1_800_124074)"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124074">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Liechtenstein;
